import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createGlobalStyle } from 'styled-components';
import './firebase/config'; // Import Firebase config to initialize it
import { APP_NAME } from './constants';
import { AuthProvider } from './contexts/AuthContext';

// Global styles
const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
  
  body {
    font-family: 'Montserrat', sans-serif;
    background-color: #f7f7f7;
    color: #333;
    line-height: 1.5;
    min-height: 100vh;
  }

  button {
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
  }
  
  input, button, textarea, select {
    font: inherit;
  }
`;

// Get the root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the app with global styles
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Add a timestamp comment for deployment reference
// Deployed: 2025-04-07 11:02:33 by rinae-delThis